import { render, staticRenderFns } from "./GroupBanner.vue?vue&type=template&id=2e347e84"
import script from "./GroupBanner.vue?vue&type=script&lang=js"
export * from "./GroupBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports